/* eslint-disable import/no-unresolved */
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import ReasonPercentageIcon from 'images/orders/reason-percentage.svg';

import { useLineItemTotal } from '../../../hooks/useLineItemTotal';
import { formatMoney } from '../../../../../../util/numberUtils';
import { formatWithCurrency } from '../../../../../../util/moneyUtils';

const LineItemTotal = ({
  product,
  currencySymbol,
  currency
}) => {
  const { t } = useTranslation('Orders');
  const {
    total,
    totalDiscount,
    finalTotal,
    hasDiscount
  } = useLineItemTotal(product);

  return (
    <div className="tw-flex tw-flex-col">
      <div className="tw-text-xs">
        {hasDiscount ? (
          <>
            <span className="tw-text-gray-500">
              {formatWithCurrency({
                symbol: currencySymbol,
                amount: finalTotal,
                currency,
                formatMoney
              })}
            </span>
            <span className="tw-text-gray-500 tw-line-through">
              {formatMoney(total)}
            </span>
            <div className="tw-flex tw-items-start tw-break-words tw-whitespace-normal">
              <img src={ReasonPercentageIcon} alt="" className="tw-w-5 tw-mr-[3px]" />
              <span className="tw-text-gray-700 tw-text-xs">
                {`${product.discount_reason ? product.discount_reason : `${t('itemsBox.discount')} `} (-${currencySymbol}${formatMoney(totalDiscount)} ${currency})`}
              </span>
            </div>
          </>
        ) : (
          <span className="tw-text-gray-500">
            {formatWithCurrency({
              symbol: currencySymbol,
              amount: total,
              currency,
              formatMoney
            })}
          </span>
        )}
      </div>
    </div>
  );
};

export default memo(LineItemTotal);
